import { ContentBlock, EditorState, Modifier, SelectionState } from "draft-js";
import { notCharacterPattern } from "../../Redux/AvailableUsers/mentions/utils";

/**
 *  Adds spaces before/after mentions if server won't be able to parse mentions.
 *  For example @AdminHi -> @Admin Hi.
 */
export const normalizeMentions = (state: EditorState) => {
    let contentState = state.getCurrentContent();

    contentState.getBlockMap().forEach((block: ContentBlock) => {
        let addedSpacesCount = 0;

        block.findEntityRanges(
            v => !!v.getEntity(),
            (start, end) => {
                // add space before mention if needed
                if (needNormalize(block.getText(), start - 1)) {
                    const startSelection = createSelection(block, start + addedSpacesCount);
                    contentState = Modifier.replaceText(contentState, startSelection, " ");
                    addedSpacesCount++;
                }

                // add space after mention if needed
                if (needNormalize(block.getText(), end)) {
                    const endSelection = createSelection(block, end + addedSpacesCount);
                    contentState = Modifier.replaceText(contentState, endSelection, " ");
                    addedSpacesCount++;
                }
            }
        );
    });

    return contentState.getPlainText();
};

const createSelection = (block: ContentBlock, offset: number) => {
    return new SelectionState({
        anchorKey: block.getKey(),
        anchorOffset: offset,
        focusKey: block.getKey(),
        focusOffset: offset,
    });
};

const notCharacterRegexp = new RegExp(notCharacterPattern);

const needNormalize = (text: string, position: number) => {
    const char = text[position];
    return char && !notCharacterRegexp.exec(char);
};
